import { DatePicker, Form, Input, Select } from "antd";
import { useLoaderData}  from "react-router";
import dayjs from "dayjs";
import SimpleFormPage from "../common/SimpleFormPage";
import { requiredField } from "../common/common";

export default function EditInspection() {
  const data = useLoaderData();
  const loadFn = (form) => form.setFieldsValue({
    date: data.date,
    outcome: data.outcome,
    notes: data.notes,
  });

  return (
    <SimpleFormPage title="Modifica ispezione" loadFn={loadFn}>
      <Form.Item
        name="date"
        label="Data"
        rules={[requiredField]}
        getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
        normalize={(value) => value?.format("YYYY-MM-DD")}
      >
        <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item name="outcome" label="Esito" rules={[requiredField]}>
        <Select
          options={[
            { label: "Positivo", value: true },
            { label: "Negativo", value: false },
          ]}
        />
      </Form.Item>
      <Form.Item name="notes" label="Note">
        <Input.TextArea rows={4} />
      </Form.Item>
    </SimpleFormPage>
  );
}
